import {
  GET_CAMPAIGNS_LIST,
  HIDE_CAMPAIGNS_LIST_LOADER,
  SET_CAMPAIGNS_LIST,
  SHOW_CAMPAIGNS_LIST_LOADER
} from "./actionTypes";

export const getCampaignsList = data => ({
  type: GET_CAMPAIGNS_LIST,
  payload: data
})

export const setCampaignsList = payload => ({
  type: SET_CAMPAIGNS_LIST,
  payload
})

export const showCampaignsListLoader = () => ({
  type: SHOW_CAMPAIGNS_LIST_LOADER
})

export const hideCampaignsListLoader = () => ({
  type: HIDE_CAMPAIGNS_LIST_LOADER
})